export const GET_TICKET_SPECIFIC_CS_REP_DETAILS = 'GET_TICKET_SPECIFIC_CS_REP_DETAILS';
